export default __webpack_public_path__ + "static/media/logo-doce-de-leite.300e164f.png";